import React, { forwardRef } from "react";

const ControllerSelect = forwardRef(
  ({ label, options = [], error, ...props }, ref) => {
    return (
      <div className="form-group mb-3">
        {label && <label className="form-label fw-semibold mb-1">{label}</label>}
        <select className="form-control" ref={ref} {...props}>
          <option value="">Select</option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {error && <div className="text-danger mt-1">{error}</div>}
      </div>
    );
  }
);

export default ControllerSelect;
